export default "__VITE_ASSET__5c9592c8__"